import React, { useCallback } from 'react'
import { hooks, ModelForm } from '@front/volcanion'
import { HookUtils } from '@front/volcanion/utils'

import { Loader } from '@front/squirtle'
import Callbacks from './callbacks'

const withForm = Component => props => {
  const navigate = hooks.useNavigate()
  const [, { openDialog }] = hooks.useDialogs()
  const [user_city, user_state] = hooks.useActiveUser({ populate: ['staffinfo'], mutator: 'staffinfo.city' })

  const formProps = {
    name: 'broadcast_form',
    model_name: 'broadcast',
    getEmptyForm: useCallback(Callbacks.getEmptyFormHandler(user_city), [user_city]),
    formToRecord: useCallback(Callbacks.formToRecordHandler(), []),
    populate: [],
    initialState: { isReadOnly: false },
    onSubmitSuccess: useCallback(Callbacks.onSubmitSuccessHandler(navigate), [navigate]),
    onSubmitFailed: useCallback(Callbacks.onSubmitFailedHandler(), []),
    beforeSubmit: useCallback(Callbacks.beforeSubmitHanbdler(openDialog), [openDialog]),
  }

  const mergedProps = {
    goBackPath: '/message'
  }

  return (
    <Loader isLoading={HookUtils.getLoadingState([user_state])}>
      <ModelForm {...formProps}>
        <Component {...mergedProps} />
      </ModelForm>
    </Loader>
  )
}

export default withForm
